import { z } from 'zod';
export const childAvatarKeySchema = z.enum(['fox', 'owl', 'panda', 'dragon']);
export const childProfileSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    displayName: z.string().min(1).max(40),
    avatarKey: childAvatarKeySchema,
    birthYear: z.number().int().min(2000).max(2100).nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createChildProfileRequestSchema = z.object({
    displayName: z.string().min(1).max(40),
    avatarKey: childAvatarKeySchema,
    birthYear: z.number().int().min(2000).max(2100).nullable().optional(),
});
export const listChildProfilesResponseSchema = z.object({
    children: z.array(childProfileSchema),
});
//# sourceMappingURL=child.js.map